import {useMemo} from 'react';
import cn from "classnames/bind";
import style from './spinner.module.scss'

export const Spinner = ({type = 8}) => {
    const className = useMemo(()=>{
        return cn({
            [style.loader_1]: type === 1,
            [style.loader_2]: type === 2,
            [style.loader_3]: type === 3,
            [style.loader_4]: type === 4,
            [style.loader_5]: type === 5,
            [style.loader_6]: type === 6,
            [style.loader_7]: type === 7,
            [style.loader_8]: type === 8,
            [style.loader_9]: type === 9,
            [style.loader_10]: type === 10,
            [style.loader_11]: type === 11,
            [style.loader_12]: type === 12,
            [style.loader_13]: type === 13,
            [style.loader_14]: type === 14,
            [style.loader_15]: type === 15,
            [style.loader_16]: type === 16,
            [style.loader_17]: type === 17,
            [style.loader_18]: type === 18,
            [style.loader_19]: type === 19,
            [style.loader_20]: type === 20,
            [style.loader_21]: type === 21,
            [style.loader_22]: type === 22,
            [style.loader_23]: type === 23,
            [style.loader_24]: type === 24,
            [style.loader_25]: type === 25,
            [style.loader_26]: type === 26,
            [style.loader_29]: type === 29,
            [style.loader_30]: type === 30,
            [style.loader_31]: type === 31,
            [style.loader_32]: type === 32,
            [style.loader_34]: type === 34,
            [style.loader_35]: type === 35,
            [style.loader_37]: type === 37,
            [style.loader_38]: type === 38,
            [style.loader_39]: type === 39,
            [style.loader_40]: type === 40,
        })
    }, [type])

    return (
        <>
            <div className={cn(style.loader_box)}>
                <div className={cn(className)} />
            </div>
        </>
    );
};